export default __webpack_public_path__ + "static/media/amico.1c5900a2.png";